// extracted by mini-css-extract-plugin
export var animationContainer = "_my-0";
export var footer = "_my-1";
export var gray = "_my-2";
export var lineItem = "_my-3";
export var lineItemImage = "_my-4";
export var lineItemInfo = "_my-5";
export var lineItemText = "_my-6";
export var lineItems = "_my-7";
export var modalContent = "_my-8";
export var options = "_my-9";
export var orderName = "_my-a";
export var refundAmount = "_my-b";